import { Organization } from '@generated/graphql';
import { useFeatureFlag } from '@hooks/FeatureFlags';
import { navigate } from 'gatsby';
import { LandingPageRecentWorkspaces } from './LandingPageRecentWorkspaces';
import { LandingPageOrganization } from './organization';
import { RemoteSessions } from './remoteSessions';
import { SampleGallery } from './sampleGallery';

type LandingPageContentProps = {
  organizations: Organization[];
  tab: string;
  organization?: Organization;
};

export const LandingPageContent = ({
  organizations,
  tab,
  organization,
}: LandingPageContentProps) => {
  const showRemoteSessionsTab = useFeatureFlag('enable-remote-sessions-on-landing');

  if (tab === 'remote-sessions') {
    if (!showRemoteSessionsTab) {
      void navigate('/');
      return null;
    }
    return <RemoteSessions />;
  }
  if (tab === 'sample-gallery') {
    return <SampleGallery />;
  }
  if (organizations.find((org) => org.organizationId === tab)) {
    return organization ? <LandingPageOrganization organization={organization} /> : null;
  }
  return <LandingPageRecentWorkspaces organizations={organizations} />;
};
